/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VcdrOrgTypeEnum = 'VCDR_INTERNAL_DEVHUB' | 'VCDR_INTERNAL_NON_DEVHUB' | 'VCDR_CUSTOMER' | 'VCDR_CUSTOMER_POC' | 'VCDR_CUSTOMER_PILOT';

export const VcdrOrgTypeEnum = {

    VCDR_INTERNAL_DEVHUB: 'VCDR_INTERNAL_DEVHUB' as VcdrOrgTypeEnum,

    VCDR_INTERNAL_NON_DEVHUB: 'VCDR_INTERNAL_NON_DEVHUB' as VcdrOrgTypeEnum,

    VCDR_CUSTOMER: 'VCDR_CUSTOMER' as VcdrOrgTypeEnum,

    VCDR_CUSTOMER_POC: 'VCDR_CUSTOMER_POC' as VcdrOrgTypeEnum,

    VCDR_CUSTOMER_PILOT: 'VCDR_CUSTOMER_PILOT' as VcdrOrgTypeEnum
};

